import { useEffect } from "react";

import { getZcLoanCollateral, isManageLeverageEligable, LoanRepayType } from "@bridgesplit/abf-react";
import { Row, Text, Tooltip } from "@bridgesplit/ui";
import { Slippage } from "app/components/common";

import { MakeRepaymentProps } from "./types";
import { ReceiveSwapButton } from "../common";
import { useManageLeverageContext } from "./ManageLeverageContext";
import PrincipalRepayment from "./PrincipalRepayment";
import CollateralRepayment from "./CollateralRepayment";

export default function LoanRepayment({ loanExpanded }: MakeRepaymentProps) {
    const { repayType, setRepayType, setForm, fullRepayWithCollateralQuoteError, fullRepayWithCollateralQuoteLoading } =
        useManageLeverageContext();
    const collateral = getZcLoanCollateral(loanExpanded);

    const { slippageWrapperProps, slippageButtonProps, slippagePercentDecimals } = Slippage.useController();
    const slippageButton = { ...slippageButtonProps, showSlippageValue: false };

    useEffect(() => {
        setForm((prev) => ({
            ...prev,
            repayWithPrincipalAmount: undefined,
            repayWithCollateralAmount: undefined,
            isFullRepay: false,
            slippagePercentDecimals: slippagePercentDecimals
        }));
    }, [repayType, setForm, slippagePercentDecimals]);

    const swapDisabled = fullRepayWithCollateralQuoteError || fullRepayWithCollateralQuoteLoading;
    const disabledText = fullRepayWithCollateralQuoteError ? "Repay with collateral quote unavailable" : undefined;

    return (
        <Slippage.Wrapper {...slippageWrapperProps}>
            <Row spaceBetween>
                <Text>
                    {repayType === LoanRepayType.Collateral
                        ? `Repay ${collateral?.metadata.symbol}`
                        : `Repay ${loanExpanded?.principalMetadata.symbol}`}
                </Text>
                {isManageLeverageEligable(loanExpanded) && (
                    <Row spacing={0.75}>
                        {repayType === LoanRepayType.Collateral && <Slippage.Button {...slippageButton} />}
                        <Tooltip title={disabledText} placement="top">
                            <ReceiveSwapButton
                                principalToken={loanExpanded?.principalMetadata}
                                collateralToken={collateral?.metadata}
                                receiveType={repayType}
                                setReceiveType={setRepayType}
                                tokenPreText="Repay in"
                                disabled={swapDisabled}
                            />
                        </Tooltip>
                    </Row>
                )}
            </Row>

            {repayType === LoanRepayType.Principal ? (
                <PrincipalRepayment loanExpanded={loanExpanded} />
            ) : (
                <CollateralRepayment loanExpanded={loanExpanded} />
            )}
        </Slippage.Wrapper>
    );
}
